import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import processingStepsService from '../services/processingStepsService';
import './AdminSyncTemplates.css';
import './PaymentPorterPage.css';

const ProcessingStepsList = () => {
    const navigate = useNavigate();
    const [steps, setSteps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState(null);

    useEffect(() => {
        processingStepsService.list()
            .then(data => setSteps(data || []))
            .catch(err => setError(err.response?.data?.message || err.message || 'Failed to load'))
            .finally(() => setLoading(false));
    }, []);

    const handleDeleteConfirm = async () => {
        if (!deleteConfirm) return;
        try {
            await processingStepsService.remove(deleteConfirm.id);
            setSteps(prev => prev.filter(s => s.id !== deleteConfirm.id));
            setDeleteConfirm(null);
        } catch (err) {
            const msg = err.response?.data?.message || 'Delete failed';
            setDeleteConfirm(prev => ({ ...prev, error: msg }));
        }
    };

    if (loading) return <div className="ast-loading">Loading processing steps…</div>;

    return (
        <div className="ast-container">
            <div className="ast-header">
                <h1>Processing Steps</h1>
                <button className="pp-rules-add-btn" onClick={() => navigate('/admin/sync-processing-steps/new')}>
                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                    New Step
                </button>
            </div>

            {error && <div className="ast-error">{error}</div>}

            <div className="ast-list">
                {steps.length === 0 && !error && (
                    <div className="ast-empty">No processing steps found.</div>
                )}
                {steps.map(s => (
                    <div key={s.id} className="ast-template-card">
                        <div className="ast-template-row">
                            <div className="ast-template-info">
                                <div className="ast-template-meta">
                                    <span className="ast-template-name">{s.name}</span>
                                    {s.description && <span className="ast-template-desc-inline">{s.description}</span>}
                                </div>
                            </div>
                            <div className="ast-template-actions">
                                <button className="pp-criteria-add-btn pp-criteria-add-btn-primary" onClick={() => navigate(`/admin/sync-processing-steps/${s.id}/edit`)}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" style={{flexShrink:0}}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                    Edit
                                </button>
                                <button className="pp-criteria-add-btn pp-criteria-add-btn-danger" onClick={() => setDeleteConfirm({ id: s.id, name: s.name })}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {deleteConfirm && (
                <div className="ast-modal-overlay">
                    <div className="ast-modal ast-modal-sm">
                        <h2>Delete Processing Step</h2>
                        {deleteConfirm.error
                            ? <p style={{ color: '#dc2626' }}>{deleteConfirm.error}</p>
                            : <p>Delete <strong>{deleteConfirm.name}</strong>?</p>
                        }
                        <div className="ast-modal-actions">
                            <button className="pp-back-btn" onClick={() => setDeleteConfirm(null)}>Cancel</button>
                            {!deleteConfirm.error && (
                                <button className="pp-criteria-add-btn pp-criteria-add-btn-danger" onClick={handleDeleteConfirm}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                                    Delete
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProcessingStepsList;
